import { Divider, Space } from 'antd'
import { isNil, toNumber } from 'lodash'

import { pretty } from '@eastcoal/common/utils/decimal'

import { BizType } from '@eastcoal/shared/enums/BizType'
import { getAuctionPriceInfo } from '@eastcoal/shared/utils/auction'

import { AuctionMemberPageStatus } from '../../../enums/AuctionMemberPageStatus'

import { AuctionListProductRenderProps } from './interface'

export const AuctionListProductRender = ({
  record: {
    bizType,
    productName,
    kindName,
    storagePlaceName,
    quantity,
    quantityUnit,
    startPrice,
    priceUnit,
    limitPrice,
    status
  }
}: AuctionListProductRenderProps) => {
  const productIfo = `${kindName}（标的物：${productName}）`
  const storagePlaceLabel =
    bizType === BizType.HOUSE_AUCTION ? '城市' : '存放地'
  const storagePlaceInfo = `${storagePlaceLabel}：${storagePlaceName ?? '-'}`
  const quantityInfo = `数量：${quantity}${quantityUnit}`
  const bidHasStarted = toNumber(status ?? 0) >= AuctionMemberPageStatus.BIDDING

  const priceInfo = getAuctionPriceInfo({ bizType, limitPrice, startPrice })
  const priceValue = bidHasStarted
    ? isNil(priceInfo.value)
      ? '无'
      : pretty(priceInfo.value) + (priceUnit ?? '')
    : '***'

  return (
    <Space orientation='vertical'>
      {productIfo}
      {storagePlaceInfo}
      <Space
        orientation='horizontal'
        separator={<Divider orientation='vertical' style={{ margin: 0 }} />}
      >
        {quantityInfo}
        {`${priceInfo.label}：${priceValue}`}
      </Space>
    </Space>
  )
}
